module.exports = __webpack_public_path__ + "static/media/WEB_61.3a6273c6.png";